var React = require('react');

function MtpCancelled (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#FFF","d":"M24 47C11.3 47 1 36.7 1 24S11.3 1 24 1s23 10.3 23 23-10.3 23-23 23z","key":0}),React.createElement("path",{"fill":"#666","d":"M24 45.5c12 0 21.5-9.6 21.5-21.5C45.5 12 36 2.5 24 2.5 12 2.5 2.5 12 2.5 24 2.5 36 12 45.5 24 45.5zm0 2.5C10.7 48 0 37.3 0 24S10.7 0 24 0s24 10.7 24 24-10.7 24-24 24z","key":1}),React.createElement("path",{"fill":"#666","d":"M32.4 17.3l-1.7-1.7-6.7 6.7-6.7-6.7-1.7 1.7 6.7 6.7-6.7 6.7 1.7 1.7 6.7-6.7 6.7 6.7 1.7-1.7-6.7-6.7","key":2})]));
}

MtpCancelled.defaultProps = {"width":"50","height":"50","viewBox":"0 0 48 48"};

module.exports = MtpCancelled;

MtpCancelled.default = MtpCancelled;
